import { useState } from 'react';
import { Box, Typography, useTheme } from '@material-ui/core';
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';

import {
  StyledMenu,
  SearchButton,
  StartAndorment,
  StyledMenuItem
} from './styled';
import SText from '../../../../sui/stext';
import { ThickIconV2 } from '../../../../sicons';
import { SearchOption } from '../../interfaces';

interface SearchDropdownProps {
  options: SearchOption[];
  selectedOption?: SearchOption;
  onSelect?: (option: SearchOption) => void;
}

const SearchDropdown = ({
  options,
  onSelect,
  selectedOption
}: SearchDropdownProps) => {
  const { palette } = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <Box onClick={e => e.stopPropagation()}>
      <SearchButton
        onClick={handleOpen}
        style={{
          backgroundColor: 'transparent'
        }}>
        {selectedOption?.icon}
        <Typography
          style={{
            color:
              selectedOption === options[1]
                ? palette?.primary?.main
                : '#5D7083',
            fontSize: 14,
            fontWeight: 500
          }}>
          {selectedOption?.label}
        </Typography>
        <ExpandMoreRoundedIcon style={{ color: '#5D7083', width: 18 }} />
      </SearchButton>

      {!!anchorEl && (
        <StyledMenu
          open
          keepMounted
          elevation={3}
          anchorEl={anchorEl}
          getContentAnchorEl={null}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}>
          {options?.map(item => (
            <StyledMenuItem
              onClick={() => {
                onSelect?.(item);
                setAnchorEl(null);
              }}>
              <StartAndorment>
                {item?.icon}
                <SText>{item?.label}</SText>
              </StartAndorment>
              {selectedOption?.value === item?.value && <ThickIconV2 />}
            </StyledMenuItem>
          ))}
        </StyledMenu>
      )}
    </Box>
  );
};

export default SearchDropdown;
